import type { Config } from '@epilot/journey-logic-commons'
import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const ConfigContext = createContext<Config | undefined>(undefined)

export const useConfig = () => {
  const context = useContext(ConfigContext)

  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }

  return context
}

type ConfigProviderProps = PropsWithChildren<{ config: Config }>

/**
 * Provides the configuration for block renderers.
 *
 * TODO: remove since block renderes are now part of the Journey App, and therefore can
 * directly access what they need
 *
 * @deprecated renderers should directly import what they need instead
 */
export const ConfigProvider = (props: ConfigProviderProps) => (
  <ConfigContext.Provider value={props.config}>
    {props.children}
  </ConfigContext.Provider>
)
